import React from 'react';
import './style.scss';
import { Image, Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const CrossSellingProductsCards = ({ products }) => (
  <div className="csp-cards">
    {products.map((p, index) => (
      <ProductCard key={index} data={p} />
    ))}
  </div>
);

const ProductCard = ({ data }) => {
  const { image, heading, text, hyperLink } = data.fields;

  return (
    <Link field={hyperLink} className="csp-card">
      <div className="csp-card-image-wrapper">
        <div className="csp-card-image-animator">
          <Image field={image} className="csp-card-image" />
        </div>
      </div>
      <div className="csp-card-description">
        <div className="csp-card-heading">
          <Text field={heading} />
        </div>
        <div className="csp-card-subheading">
          <div className="csp-card-arrow" />
          <RichText className="csp-card-text" field={text} />
        </div>
      </div>
    </Link>
  );
};

export default CrossSellingProductsCards;
